<template>
  <el-breadcrumb separator="»">
    <el-breadcrumb-item class="item" v-for="(item,index) in items" :key="index" @click="onClickItem(item.id,index)">
      <span class="gray-color">{{ item.title }}</span>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  name: "BreadCrumbDynamic",
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    onClickItem(id, index) {
      if (index + 1 !== this.items.length) {
        this.$emit('onClickItem', id,index+1)
      }
    }
  }
}
</script>

<style scoped>
.item {
  cursor: pointer;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>
